import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 pr-0 mb-1" }, "اطلاعیه ها")
], -1)
const _hoisted_4 = {
  class: "card-toolbar",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-trigger": "hover",
  title: "Click to add a user"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "svg-icon svg-icon-3" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ایجاد اطلاعیه ")
const _hoisted_8 = { class: "card-body card-scroll" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = {
  style: {"width":"100%"},
  class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2 custom-loading-svg"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", null, "عنوان | متن"),
    /*#__PURE__*/_createElementVNode("th", null, "وضعیت"),
    /*#__PURE__*/_createElementVNode("th", null, "رنگ"),
    /*#__PURE__*/_createElementVNode("th", null, "شروع | پایان"),
    /*#__PURE__*/_createElementVNode("th", null, "عملیات")
  ])
], -1)
const _hoisted_12 = { class: "d-flex flex-column align-items-center" }
const _hoisted_13 = { class: "text-dark text-nowrap fw-bolder mb-1 fs-6" }
const _hoisted_14 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_15 = { class: "d-flex flex-column flex-nowrap" }
const _hoisted_16 = ["disabled", "onClick"]
const _hoisted_17 = { class: "svg-icon svg-icon-3" }
const _hoisted_18 = ["disabled", "onClick"]
const _hoisted_19 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Status = _resolveComponent("Status")!
  const _component_Date = _resolveComponent("Date")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_CreateNoticeModal = _resolveComponent("CreateNoticeModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            disabled: !_ctx.permission?.includes('notice_create'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actionType = 'create')),
            class: "btn btn-primary",
            "data-bs-toggle": "modal",
            "data-bs-target": "#kt_modal_create_notice_modal"
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" })
            ]),
            _hoisted_7
          ], 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives((_openBlock(), _createElementBlock("table", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(item.description), 1)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_Status, {
                      status: item.status
                    }, null, 8, ["status"])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge badge-circle w-20px h-20px", ['badge-' + item.color]])
                    }, null, 2)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_15, [
                      (item.start_datetime)
                        ? (_openBlock(), _createBlock(_component_Date, {
                            key: 0,
                            classes: "text-muted",
                            date: item.start_datetime
                          }, null, 8, ["date"]))
                        : _createCommentVNode("", true),
                      (item.finish_datetime)
                        ? (_openBlock(), _createBlock(_component_Date, {
                            key: 1,
                            date: item.finish_datetime
                          }, null, 8, ["date"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_el_tooltip, {
                      content: "ویرایش",
                      placement: "top",
                      effect: "light"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          disabled: 
                        !_ctx.permission?.includes('notice_view') ||
                        !_ctx.permission?.includes('notice_update')
                      ,
                          onClick: ($event: any) => {
                        _ctx.setData(item.id);
                        _ctx.actionType = 'edit';
                      },
                          class: "btn btn-icon btn-light-warning btn-sm me-1",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_create_notice_modal"
                        }, [
                          _createElementVNode("span", _hoisted_17, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                          ])
                        ], 8, _hoisted_16)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_tooltip, {
                      content: "حذف",
                      placement: "top",
                      effect: "light"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          disabled: !_ctx.permission?.includes('notice_delete'),
                          class: "btn btn-icon btn-light-danger btn-sm me-1",
                          onClick: ($event: any) => (_ctx.deleteNotice(item.id))
                        }, [
                          _createElementVNode("span", _hoisted_19, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                          ])
                        ], 8, _hoisted_18)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]))
              }), 128))
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          (_ctx.pagination && _ctx.pagination.total_pages > 1)
            ? (_openBlock(), _createBlock(_component_el_pagination, {
                key: 0,
                background: "",
                layout: "prev, pager, next",
                class: "mt-4 mb-4",
                total: _ctx.pagination.total,
                currentPage: _ctx.pagination.current_page,
                "page-size": _ctx.pagination.per_page,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_CreateNoticeModal, {
      id: _ctx.editNoticeId,
      onRefreshList: _ctx.getItems,
      ref: "createNoticeModalRef",
      type: _ctx.actionType
    }, null, 8, ["id", "onRefreshList", "type"])
  ], 64))
}